import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Box, Typography, Card, List, ListItem, CardContent, ListItemText } from '@mui/material';


const ExamInstructions = ({ handleNext }) => {
    const { examId } = useParams();
    const navigate = useNavigate();

    const handleStartExam = () => {
        handleNext();
    };



    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
            <Card sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Exam Instructions
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Important Guidelines:
                </Typography>

                <List>
                    <ListItem>
                        <ListItemText primary="1. The exam will be conducted in full-screen mode" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="2. Switching tabs/windows will result in warnings" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="3. You must keep your camera on throughout the exam" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="4. Maximum allowed warnings: 3 (exam will auto-submit after)" />
                    </ListItem>
                </List>

                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleStartExam}
                    >
                        Start Exam
                    </Button>
                </Box>
            </Card>
        </Box>
    );
};

export default ExamInstructions;